import { FormEvent, useState } from 'react';

import { ICreateTokenSaleResponse, useCreateTokenSaleMutation } from '@entities/trades/token-sell';
import { ITraderWallet } from '@entities/trades/wallet';
import { useMultiStepForm } from '@features/multi-step-form';
import { FormItemWithError } from '@shared/components/Form';
import { useModal } from '@shared/components/Modal';

interface IProps<T> {
  wallet: T;
}

export const StepCreate = <T extends ITraderWallet>({ wallet }: IProps<T>) => {
  const [amount, setAmount] = useState('');
  const [createTokenSale, { isLoading, isError, error }] = useCreateTokenSaleMutation();
  const { nextStep, setData } = useMultiStepForm<ICreateTokenSaleResponse>();
  const { closeModal } = useModal();

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const numAmount = Number(amount);
    if (!numAmount || numAmount <= 0) return;

    const result = await createTokenSale({
      wallet_id: wallet.id,
      amount: numAmount,
    });

    if ('data' in result) {
      setData(result.data);
      nextStep();
    }
  };

  return (
    <>
      <h2>Create Token Sale</h2>
      <p>
        Please enter amount and click Create. This will create a New token sale for the trading
        wallet which should be confirmed by UTR to get Pending / Success status.
      </p>

      <form className='popup-form' onSubmit={handleSubmit}>
        <FormItemWithError name='amount' label='Amount' isError={isError} error={error}>
          <input
            type='number'
            name='amount'
            id='amount'
            value={amount}
            onChange={e => setAmount(e.target.value)}
            step='1'
            min='1'
          />
        </FormItemWithError>

        <div className='form-submit'>
          <button type='submit' disabled={isLoading || !amount || Number(amount) <= 0}>
            Create token sale
          </button>
          <button type='button' className='secondary-btn' onClick={closeModal}>
            Cancel
          </button>
        </div>
      </form>
    </>
  );
};
